<template>
  <div class="wrapper">
    <div class="content" >

      <el-tabs v-model="activeName" v-if="videoArray.length>0">
        <el-tab-pane label="全部" name="first">
          <el-row :gutter="10">
            <div v-for="(item, index) in videoArray">
              <el-col
                :span="12"
                v-for="(item1, index1) in item.var"
                :key="index1"
              >
                <div class="grid-content bg-purple">
                    <iframe src="https://lf9-cdn-tos.bytecdntp.com/cdn/expire-1-M/byted-player-videos/1.0.0/xgplayer-demo.mp4" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
                    <!-- <span v-if="item1.key!==''" class="item_span_type">{{ item1.key }}</span> -->
                  <!-- <el-image class="item_img" :src="item1.img==''?require('../../assets/images/videobg.png'):item1.img" @click="videoClick(item1)" /> -->

                  <span
                    style="
                      font-size: 16px;
                      color: rgb(70, 73, 73);
                      text-align: center;
                      font-weight: bold;
                    "
                    >{{ item1.name }}</span
                  >

                  <span
                    style="
                      font-size: 17px;
                      float: right;
                      bottom: 50px;
                      color: rgb(166, 170, 170);
                    "
                    ><i class="el-icon-time"></i>{{ item1.time }}
                  </span>
                </div>
              </el-col>
            </div>
        </el-row>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in videoArray"
          :key="index"
          :label="item.title"
          :name="item.name"
        >
        <el-row :gutter="10">
          <el-col
            :span="12"
            v-for="(item1, index1) in item.var"
            :key="index1"
          >
            <div class="grid-content bg-purple">
            <el-image class="item_img" :src="item1.img==''?require('../../assets/images/videobg.png'):item1.img" @click="videoClick(item1)" />
              <span
                style="
                  font-size: 16px;
                  color: rgb(70, 73, 73);
                  text-align: center;
                  font-weight: bold;
                "
                >{{ item1.name }}</span
              >

              <span
                style="
                  font-size: 17px;
                  float: right;
                  bottom: 50px;
                  color: rgb(166, 170, 170);
                "
                ><i class="el-icon-time"></i>{{ item1.time }}
              </span>
            </div>
          </el-col>
        </el-row>
        </el-tab-pane>
      </el-tabs>
      <h3 v-else style=" 
          display:flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 20%;
          color: black;">暂无监控</h3>               
    </div>
  </div>
</template>

<script>
import dataUrl from "../../libs/js/interfaceAddress.js";

export default {
  name: 'VideoPlay',
  components: {},
  props: {},
  data() {
    return {
      videoArray: [],
      activeName: 'first',
      tab_item_index: 0
    }
  },
  watch: {},
  computed: {},
  methods: {
    requestdeviceVideoList() {
      this.$http.get(dataUrl.interfaceAddress.getDevVideoList)
        .then(res => {
          if (res.data.code === 0) {
            this.videoArray = res.data.body
            }
          })
        .catch(err => {
          console.log(err);
        });
    },
    videoClick(item) {
      // this.$router.push({
      //   name: 'VideoPlay',
      //   path: './VideoPlay',
      //   params: { videoArray: JSON.stringify(this.videoArray), model: JSON.stringify(item) }
      // })
    }
  },
  mounted() {
    this.requestdeviceVideoList()
  }
}
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  //  background-color: blueviolet;
}

.content {
  // background: url("../../assets/img/videobg.png") no-repeat;
  // background-size: 100% 100%;
  position: relative;
  // width: 99%;
  // height: 100%;
  // top: 70px;
  // background-color: brown;
  // // bottom: 0%;
}
.grid-content {
  border-radius: 400px;
  min-height: 36px;
}
.grid-content iframe {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transform-origin: top left;
        transform: scale(1)
    } 
.item_span_type {
    font-size: 12px;
    font-weight: 1000;
    color: #292626;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(220, 223, 230, 1);
    margin: 5px;
    padding: 5px;
  }
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 100px;
  }
}
.el-col {
  border-radius: 100px;
  height: 320px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  //  background: rgba(17, 173, 235, 0.5);
  //  width: 400px;
  height: 100%;
  .item_img {
    width: 100%;
    height: 90%;
  }
  border-radius:10px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 10px;
  background-color: burlywood;
}
</style>



// WEBPACK FOOTER //
// src/components/video/CloudVideo.vue